import __ from 'lodash'
import React from 'react'
import PropTypes from "prop-types";
import cn from 'classnames'
import _ from '../../../misc/i18n'
import Axios from 'axios'
import Moment from 'moment'
import { Form, Button } from 'react-bootstrap'
import FA from 'react-fontawesome'


export default class NotificationsContainer extends React.Component {
    constructor() {
        super();
        this.state = { isOpen: false, notification: { messages: [] } };
    }
    handleOnBellClick = drzwi => {
        this.setState({ isOpen: !this.state.isOpen });
    }
    handleOnDeleteClick = messageProps => {
        Axios.post('/api/notifications/messageDelete/' + messageProps.notificationId)
            .then(response => this.setState({ notification: response.data }))
    }
    handleOnEnvelopeClick = messageProps => {
        Axios.post('/api/notifications/messageReadToggle/' + messageProps.notificationId)
            .then(response => this.setState({ notification: response.data }))
    }
    handleOnLinkClick = messageProps => {
        if (!messageProps.isRead) {
            Axios.post('/api/notifications/messageReadToggle/' + messageProps.notificationId)
                .then(response => this.setState({ notification: response.data }))
        }
    }
    handleNotifyByEmailToggle = () => {
        Axios.post('/api/notifications/notifyByEmailToggle', { notifyByEmail: !this.state.notification.notifyByEmail })
            .then(res => {
                this.setState(prevState => {
                    return {
                        notification: { ...prevState.notification, notifyByEmail: !prevState.notification.notifyByEmail }
                    }
                });
            })
            .catch(err => console.log(err))
    }
    componentDidMount() {
        Axios.get('/api/notifications/')
            .then(response => {
                let notification = response.data, messages = notification.messages;
                if (notification) {
                    // sort our notification messages
                    // unread first, then chronologically
                    messages = __.orderBy(messages, ['isRead', 'utworzono'], ['asc', 'desc']);
                    notification.messages = messages;
                    this.setState({ notification: notification })
                }
            })
            .catch(err => console.log(err))
    }

    render() {
        let { handleOnBellClick, handleOnEnvelopeClick, handleOnDeleteClick, handleOnLinkClick, handleNotifyByEmailToggle,
            state: { isOpen: sIsOpen, notification: { messages, notifyByEmail } } } = this,
            notificationsCount = __.reduce(this.state.notification.messages, (count, message) => count + (message.isRead ? 0 : 1), 0);
        return (
            <Notifications onBellClick={handleOnBellClick} notificationsCount={notificationsCount} isOpen={sIsOpen}
                onNotifyByEmailChange={handleNotifyByEmailToggle} notifyByEmail={notifyByEmail}
            >

                {__.map(messages, (message, ix) =>
                    <div onEnvelopeClick={handleOnEnvelopeClick} onDeleteClick={handleOnDeleteClick} onLinkClick={handleOnLinkClick}
                        key={ix} notificationId={message._id} {...message} ></div>)
                }
            </Notifications>
        )
    }
}

class Notifications extends React.Component {
    static propTypes = {
        notificationsCount: PropTypes.number,
        onBellCLick: PropTypes.func,
        isOpen: PropTypes.bool.isRequired
    };

    onClick = () => {
        this.props.onClick();
    };

    static defaultProps = {

    };

    render() {
        const { props: { notificationsCount, onBellClick, isOpen, children } } = this,
            buttonColor = notificationsCount > 0 ? 'btn-primary' : 'btn-secondary',
            badgeHTML = notificationsCount > 0 && <span style={{ position: 'absolute', left: 25, top: 5 }} className="badge badge-danger text-light">{notificationsCount}</span>;

        return <div style={{ position: 'relative' }}>
            <button title="Powiadomienia" type="button" className={cn("btn", buttonColor)} onClick={onBellClick}>
                <span className={cn("fa fa-bell text-white")}></span> {badgeHTML}
            </button>
            {isOpen && (
                <div className="card" style={{ width: 400, zIndex: 100 }}>
                    <div className="card-header small">
                        {_('Powiadomienia')}
                        <NotifyByEmailTick notifyByEmail={this.props.notifyByEmail} onChange={this.props.onNotifyByEmailChange} />
                    </div>
                    <NotificationsList>
                        {children.length === 0 &&
                            <li className="list-group-item">
                                <div className='small'>{_("Brak powiadomień do wyświetlenia")}</div>
                            </li>
                        }
                        {React.Children.map(children, child => {
                            return <NotificationItem {...child.props} />
                        })}
                    </NotificationsList>
                    <div className="card-footer small">
                        <Button title="Zamknij" variant="link" className="float-right">
                            <FA className="text-secondary" name="times" onClick={onBellClick} />
                        </Button>
                    </div>
                </div>
            )
            }
        </div>
    }
}

class NotifyByEmailTick extends React.Component {
    static propTypes = {
        notifyByEmail: PropTypes.bool.isRequired,
        onChange: PropTypes.func
    }
    render() {
        const { props: { notifyByEmail, onChange } } = this;
        return (
            <span className="float-right">
                <Form.Check
                    type="switch"
                    label={_("Powiadamiaj emailem")}
                    id={"notifyByEmailCheck"}
                    checked={notifyByEmail}
                    onChange={onChange}
                />
                {/* <div className="form-check-inline float-right">
                    <input checked={notifyByEmail} onChange={onChange} className="form-check-input" type="checkbox" id="gridCheck" />
                    <label className="form-check-label" htmlFor="gridCheck">
                        Powiadamiaj emailem
                        </label>
                </div> */}
            </span>
        )
    }
}

function NotificationsList(props) {
    return <ul className="list-group list-group-flush" style={{ maxHeight: 350, overflow: 'auto' }}>
        {props.children}
    </ul>
}


function NotificationItem(props) {
    const envelopeClassName = props.isRead ? 'fa-envelope-open text-secondary' : 'fa-envelope text-primary',
        envelopeTitle = props.isRead ? _("Oznacz jako nieprzeczytane") : _("Oznacz jako przeczytane");
    return <li className="list-group-item">
        <div className='clearfix'>
            <div className="float-left" style={{ width: 314 }}>
                <div className='small'>{_(props.messageContent)}</div>
                <div className='small'>
                    <a target="_blank" rel="noopener noreferrer" href={props.linkAddress}
                        onClick={() => props.onLinkClick(props)}
                        title={_('Zobacz więcej informacji')}>
                        {props.linkTitle}
                    </a>
                </div>
            </div>
            <div className="notifications-icons float-right">
                <div><i style={{ cursor: 'pointer' }} onClick={() => props.onDeleteClick(props)} className="text-danger fas fa-trash-alt" title={_('Usuń')}></i></div>
                <div><i style={{ cursor: 'pointer' }} onClick={() => props.onEnvelopeClick(props)} className={cn("fas", envelopeClassName)} title={envelopeTitle}></i></div>
            </div>
        </div>
        <div className="small text-muted text-right" style={{
            position: "relative",
            marginBottom: -17,
            right: -14,
            top: -5
        }}><span className="small">{Moment(props.utworzono).format('YYYY-MM-DD HH:mm')}</span></div>
    </li>
}

NotificationItem.propTypes = {
    notificationId: PropTypes.string.isRequired,
    isRead: PropTypes.bool.isRequired,
    onDeleteClick: PropTypes.func,
    onEnvelopeClick: PropTypes.func,
    onLinkClick: PropTypes.func
}
